import type { useQuery } from "convex/react";

import type { billingGetTierInfo } from "~/api-refs";

export type Tier = "free" | "growth" | "enterprise";

export type TierInfo = NonNullable<
  ReturnType<typeof useQuery<typeof billingGetTierInfo>>
>;

export const TIER_LABELS: Record<Tier, string> &
  Record<string, string | undefined> = {
  free: "Free",
  growth: "Growth",
  enterprise: "Enterprise",
};

export const TIER_DESCRIPTIONS: Record<Tier, string> &
  Record<string, string | undefined> = {
  free: "4% processing fee, no monthly cost",
  growth: "3% processing fee, per-location monthly pricing",
  enterprise: "2.5% processing fee, per-location monthly pricing",
};
